import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InvoicesChargebacksService } from '../../invoices-chargebacks.service';

@Component({
  selector: 'app-ap-charge-back-tabs',
  templateUrl: './ap-charge-back-tabs.component.html',
  styleUrls: ['./ap-charge-back-tabs.component.scss']
})
export class ApChargeBackTabsComponent implements OnInit {

  // params
  id: string;

  // data
  chargeBack: any;

  // tabs base route
  baseRoute: string;

  constructor(
    private _route: ActivatedRoute,
    private _invCbSvc: InvoicesChargebacksService
  ) { }

  ngOnInit() {

    this.id = this._route.snapshot.paramMap.get('id');

    this.baseRoute = `/accounting/accounts-payable/invoices-charge-backs/charge-backs/${this.id}`;

    this._invCbSvc.ChargeBack.subscribe((res: any) => {
      this.chargeBack = res;
    });

  }

}
